import { render, staticRenderFns } from "./MessageAttachment.vue?vue&type=template&id=4f3afea4&scoped=true"
import script from "./MessageAttachment.vue?vue&type=script&lang=js"
export * from "./MessageAttachment.vue?vue&type=script&lang=js"
import style0 from "./MessageAttachment.vue?vue&type=style&index=0&id=4f3afea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f3afea4",
  null
  
)

export default component.exports